import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const RevokeAccountInviteMutation = graphql.persisted(
  "RevokeAccountInvite",
  graphql(`
    mutation RevokeAccountInvite($personId: ID!) {
      revokeAccountInvite(input: { personId: $personId }) {
        person {
          id
          hasUserAccount
          accountInviteStatus
          accountInviteEmail
          accountInviteExpiresAt
        }
        userErrors { message path }
      }
    }
  `)
);

export { RevokeAccountInviteMutation };

export function useRevokeAccountInvite() {
  return useMutation(RevokeAccountInviteMutation);
}
